import {
  GET_SALES_REPORT_ORDER_COLUMNSVALUE_REQUEST,
  GET_SALES_REPORT_ORDER_COLUMNSVALUE_SUCCESS,
  GET_SALES_REPORT_ORDER_COLUMNSVALUE_ERROR,
} from "../actions/types";

export const salesReportColumnValue = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SALES_REPORT_ORDER_COLUMNSVALUE_REQUEST:
      return {
        loading: true,
      };
    case GET_SALES_REPORT_ORDER_COLUMNSVALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SALES_REPORT_ORDER_COLUMNSVALUE_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
